/*
  based entirely on https://github.com/featurist/browser-pdf-support
*/

export const hasAcrobatInstalled = ()=>{
  function getActiveXObject(name) {
    try { return new ActiveXObject(name); } catch(e) {}
  }

  return getActiveXObject('AcroPDF.PDF') || getActiveXObject('PDF.PdfCtrl');
};

export const isIos = ()=> {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const canViewPDF = ()=> {
  return navigator.mimeTypes['application/pdf'] || hasAcrobatInstalled() || isIos();
};
